import { t } from '~/helpers/localization';

export enum CONTENT_STATE {
  ERROR,
  CLAIM,
  CLAIMED,
  REFRESH_EMPTY,
  REFRESH_CLAIM_NOLOSS,
  REFRESH_CLAIM,
  REFRESH,
}

export const getInitialContentState: (props: {
  isActionClaim: boolean;
  hasClaimableRewards: boolean;
  hasNewRewards: boolean;
  hasAllNewRewards: boolean;
}) => CONTENT_STATE = ({ isActionClaim, hasClaimableRewards, hasNewRewards, hasAllNewRewards }) => {
  if (isActionClaim) {
    return CONTENT_STATE.CLAIM;
  }

  if (hasClaimableRewards) {
    if (!hasNewRewards) {
      return CONTENT_STATE.REFRESH_CLAIM_NOLOSS;
    }
    return CONTENT_STATE.REFRESH_CLAIM;
  }
  if (hasAllNewRewards) {
    return CONTENT_STATE.REFRESH_EMPTY;
  }
  return CONTENT_STATE.REFRESH;
};

export const getContent = (state: CONTENT_STATE) => {
  switch (state) {
    case CONTENT_STATE.ERROR:
      return {
        header: t('Something Went Wrong'),
        message: t('Something went wrong while issuing the rewards. Please try again.'),
        button: t('Try again'),
      };

    case CONTENT_STATE.REFRESH_EMPTY:
      return {
        header: t('Refresh'),
        message: t(
          'Since you haven’t earned any rewards from this set, the rewards will return to the rewards pool upon refreshing.',
        ),
        button: t('Refresh'),
      };

    case CONTENT_STATE.REFRESH_CLAIM_NOLOSS:
      return {
        header: t('Claim and refresh'),
        message: t('You will receive the following rewards'),
        button: t('Claim and refresh'),
      };

    case CONTENT_STATE.REFRESH_CLAIM:
      return {
        header: t('Claim and refresh'),
        warning: t(
          'If you refresh now, you will receive the rewards you want to claim, but those with unmet conditions will be lost. To avoid this, you can cancel now, play in a division, claim all rewards, and then refresh.',
        ),
        button: t('Claim and Refresh'),
      };

    case CONTENT_STATE.REFRESH:
      return {
        header: t('Lost Rewards'),
        warning: t(
          'If you refresh now, the rewards with unmet conditions will be lost. To avoid this, you can cancel now, play in a division, claim the rewards, and then refresh.',
        ),
        button: t('Refresh'),
      };

    case CONTENT_STATE.CLAIMED:
      return {
        header: t('Congratulations'),
        message: t('You received the following rewards'),
      };

    case CONTENT_STATE.CLAIM:
      return {
        header: t('Rewards'),
        message: t('You will receive the following rewards'),
        button: t('Claim'),
      };

    default:
      return {};
  }
};
